import { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from '@bwoty-web/ui-kit';
import {
  ICON_MISC_WHEELCHAIR,
  ICON_UI_CHEVRON_DOWN,
  ICON_UI_CHEVRON_UP,
} from '@bwoty-web/ui-kit/icons';
import cx from 'classnames';
import SectionParagraph from './sectionParagraph';
import './roomAccessibility.scss';

const TableParagraph = ({ item }) => {
  if (item.type === 'table2col')
    return (
      <div>
        <h4 className="gw-room-accessibility__heading">{item.heading}</h4>
        <dl className="gw-room-accessibility__table">
          {item.paragraphs?.map((paragraph, pIndex) => {
            return (
              <div
                className="gw-room-accessibility__row"
                key={`room-accessibility-row-${pIndex}`}
              >
                <dt>{paragraph.heading}</dt>
                <dd>{paragraph.content}</dd>
              </div>
            );
          })}
        </dl>
      </div>
    );
  return item.paragraphs?.map((paragraph, pIndex) => (
    <SectionParagraph
      className="gw-room-accessibility__paragraph"
      paragraph={paragraph}
      key={`room-accessibility-paragraph-${pIndex}`}
    />
  ));
};

export const RoomAccessibility = ({
  accessibilityItems = [],
  itemsToShow = 1,
  texts = {},
}) => {
  const [hideItems, setHideItems] = useState(true);

  if (!accessibilityItems || accessibilityItems.length === 0) return null;

  const [firstItem, ...restItems] = accessibilityItems;
  const hasExcessItems = restItems.length > itemsToShow;

  return (
    <div className="gw-room-accessibility__wrapper">
      <div>
        <div className={cx('gw-room-accessibility__heading--icon')}>
          <Icon path={ICON_MISC_WHEELCHAIR} />
          <h3>{firstItem.heading}</h3>
        </div>
        {firstItem.paragraphs.map((paragraph, pIndex) => (
          <SectionParagraph
            className="gw-room-accessibility__paragraph"
            paragraph={paragraph}
            key={`room-accessibility-first-paragraph-${pIndex}`}
          />
        ))}
      </div>
      {restItems.slice(0, itemsToShow).map((item, itemIndex) => (
        <TableParagraph
          item={item}
          key={`room-accessibility-item-${itemIndex}`}
        />
      ))}
      {hasExcessItems && (
        <Button
          className="gw-room-accessibility__toggle-button"
          onClick={() => setHideItems(!hideItems)}
          fullWidthMobile
          iconAfter={
            <Icon
              path={hideItems ? ICON_UI_CHEVRON_DOWN : ICON_UI_CHEVRON_UP}
            />
          }
          aria-expanded={!hideItems}
        >
          {hideItems ? texts.showMore || '' : texts.showLess || ''}
        </Button>
      )}
      {hasExcessItems &&
        !hideItems &&
        restItems
          .slice(itemsToShow, restItems.length)
          .map((item, itemIndex) => (
            <TableParagraph
              item={item}
              key={`room-accessibility-hidden-item-${itemIndex}`}
            />
          ))}
    </div>
  );
};

TableParagraph.propTypes = {
  item: PropTypes.shape({
    type: PropTypes.string,
    heading: PropTypes.string,
    paragraphs: PropTypes.arrayOf(
      PropTypes.shape({
        heading: PropTypes.string,
        content: PropTypes.string,
      }),
    ),
  }),
};

RoomAccessibility.propTypes = {
  accessibilityItems: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      heading: PropTypes.string,
      paragraphs: PropTypes.arrayOf(
        PropTypes.shape({
          heading: PropTypes.string,
          content: PropTypes.string,
        }),
      ),
    }),
  ),
  itemsToShow: PropTypes.number,
  texts: PropTypes.shape({
    showMore: PropTypes.string,
    showLess: PropTypes.string,
  }),
};
